import { styled } from '@mui/material';
import { useContext } from 'react';
import AuthContext from '../../contexts/AuthContext';
import NavigationContext from '../../contexts/NavigationContext';
import Avatar from '../Avatar';

const Container = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isNameVisible',
})<{
  isNameVisible?: boolean;
}>(({ theme, isNameVisible }) => ({
  display: 'flex',
  padding: `0 ${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(2)}`,
  justifyContent: `${isNameVisible ? 'flex-end' : 'center'}`,
  alignItems: 'center',
}));

const UserName = styled('div')(({ theme }) => ({
  fontWeight: 500,

  marginRight: theme.spacing(),
  textOverflow: 'ellipsis',
  overflow: 'hidden',
}));

export const User = (): JSX.Element => {
  const { isDrawerMini } = useContext(NavigationContext);
  const { user } = useContext(AuthContext);

  return (
    <Container isNameVisible={isDrawerMini}>
      {isDrawerMini && <UserName>{user?.name || 'Desconhecido'}</UserName>}
      <Avatar src={user?.photoUrl! || undefined} />
    </Container>
  );
};

export default User;
